import { OnLoadType } from '@/effects/types';
import { EsConfigType } from '@/asset/AssetTask/templates/Cascade/effect';
import { Auth } from '@/store/type';

declare global {
  interface Window {
    pageProps?: {
      utils?: Utils;
      pageType?: PageType;
      recordId?: string;
      taskId?: string;
    };
  }
}

export enum PageType {
  Create = 'create',
  Edit = 'edit',
  Detail = 'detail',
  List = 'list',
}

export interface Utils {
  buiNavigate?: any;
  qiankun?: any;
  queryParams?: object;
  routeParams: object;
  saveFail?: any;
  saveSuccess?: any;
  setSearchParams?: any;
}

interface FreeBtnInfoType {
  text?: string;
  cate?: string;
  position?: string;
  'position-direction'?: string;
  'position-module'?: string;
  freeJs?: string;
  id?: string;
  visible?: boolean;
}

export interface PageConfigType {
  // 高级配置，现在每个页面有一份对应配置
  createPageConfig?: Record<string, any>;
  detailPageConfig?: Record<string, any>;
  freeBtnConfig: FreeBtnInfoType[];
  freedomComponents: any[];
  pageModuleConfig: Record<string, {
    isFileModule: boolean;
    isUseGroup: boolean;
    sequence: number;
    tabName: string;
    tabShow: boolean;
    groupTitle: string[];
    selectType?: 'checkbox' | 'radio' | 'none';
    showTableIndex?: boolean;
    canImport?: boolean;
    rowCopyable?: boolean;
    hideListAdd?: boolean;
    hideRowDelete?: boolean;
    addButtonText?: string;
    hidePagination?: boolean;
    groupField: Array<Array<{
      fieldID: string;
      label: string;
      name: string;
    }>>;
    configList: Array<{
      fieldID: string;
      label: string;
      moduleName: string;
      name: string;
      showSource: boolean;
      showSearch?: boolean;
      relationName?: string;
      searchOptions?: {
        defaultValue: string;
      };
      showOptions?: {
        isSingleLine?: boolean;
        width?: string | number;
        defaultValue?: string;
      };
    }>;
    /** 行不可编辑计算表达式 */
    rowSelectionDisabled?: string;
    mobileFieldShow?: string[];
  }>;
  topTableBtnConfig?: any;
  rulePageValue: any[];
  listPageConfig?: {
    headerBtns: string[];
    rowBtns: string[];
    rowClickLink: boolean;
    eventList: EsConfigType[];
    optionsActionType: string[];
  };
}


/** 任务表格 */
export interface AssetsTaskTableProps {
  /** 任务id */
  taskId: string;
  /** 某条记录的id，在详情页和编辑页需要 */
  recordId?: string;
  /** 路由相关方法 */
  utils?: Utils;
  /** 页面配置定义 */
  pageConfig?: PageConfigType;
  onLoad?: (params: { meta: any; data: any; events: any; actions: any }) => void;
  events?: Record<string, Function>;
  qiankun?: Record<string, any>;
  optionsActionType: 'drawer' | 'modal';
  filterParams?: any;
  rowSelection?: any;
  selectType?: 'checkbox' | 'radio';
  showTableIndex?: 'on' | 'off';
  onSelectedRows?: any;
  isMobile?: boolean;
  auth?: Auth[];
  selectedRowKeys?: string | string[];
}

/** 任务模型下字段参数 */
export interface TaskFieldType {
  field_code: string;
  field_from: string;
  field_id: string;
  field_name: string;
  id: string;
  is_deleted: boolean;
  is_main_entity: boolean;
  logic_entity_id: string;
  sequence: string;
  source: string;
  task_id: string;
  updated_at: string;
  required?: boolean;
}

export interface AssetsTaskProps {
  /** 任务id */
  taskId: string;
  /** 页面类型 */
  pageType: PageType;
  /** 某条记录的id，在详情页和编辑页需要 */
  recordId?: string;
  /** 路由相关方法 */
  utils?: Utils;
  /** 页面配置定义 */
  pageConfig?: PageConfigType;
  onLoad?: OnLoadType;
  events?: Record<string, Function>;
  isMobile?: boolean;
  propValues?: Record<string, any>;
}


export interface EventType {
  /** 通用参数 */
  id?: string;
  code?: string;
  rowIndex?: number | '*';
  fieldName: string;
  moduleName: string;
  name?: string;
  actionType: 'openUrl' | 'copyData' | 'callback';
  touchConfig: 'click' | 'change';
  /** 回掉参数 */
  fun?: (value: number | string, params: FunParamsType) => void;
}

export interface FunParamsType {
  rowIndex: number | undefined;
  event: EventType;
  type?: 'light';
  params?: any;
}

export interface AssetFieldProps {
  moduleCode?: string;
  fieldCode?: string;
  disabled?: boolean;
  isEdit?: boolean;
  value?: boolean;
  onChange?: (value: any) => void;
  componentsCode?: string;
  componentsOptions?: any;
  style?: any;
}


export interface FieldMeta {
  name: string;
  code: string;
  componentsCode?: string;
  options: {
    componentsOptions?: string;
  };
  dataType: string;
}
